exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.iframe__autoSize--3kYbL {\n  width: 100%;\n  height: 100%;\n  background-clip: padding-box;\n  margin: auto;\n  position: relative;\n}\n\n.iframe__autoSize--loading--1a-gJ {\n  background-color: #8b9195;\n}\n\n.iframe__loading--39ZYo {\n  width: 80px;\n  height: 80px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%,-50%);\n}\n", ""]);

// exports
exports.locals = {
	"autoSize": "iframe__autoSize--3kYbL",
	"autoSize--loading": "iframe__autoSize--loading--1a-gJ",
	"loading": "iframe__loading--39ZYo"
};